// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {GridList, GridTile} from 'material-ui/GridList';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import EditIcon from 'material-ui/svg-icons/image/edit';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import TournamentCompetition from '../tournamentCompetition';
import moment from 'moment';

class ViewTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      tournament: {},
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      open: false,
      dialog_open: false,
      competitionView:false,
      prev_competition_details:[],
      competitions_id:'',
      addNewCompetitionView:false,
      selected_competition_id:'',
      deleteView:false,
    };
    this.getCompetitionDetail = this.getCompetitionDetail.bind(this);
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  componentDidMount() {
    this.getTournamentList();
    this.getCompetitionDetail();
    
  }
  
  toAddCompetitionView(){
    this.setState({addNewCompetitionView:!this.state.addNewCompetitionView})
  }
  

  getCompetitionDetail(){
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/tournament/get_competition_details/?tournament_id=${this.state.id}`;
        const options = {...defaultOptions};
        options['method'] = 'get';
        options['headers'] = {'content-type': 'application/json'}
        // options['body'] = JSON.stringify({
        //                      'tournament_id': this.state.id
        //                    });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({prev_competition_details: data.competitions_list}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  onComptitionView(competitions_id){
    console.log(competitions_id)
    this.setState({competitions_id:competitions_id,addNewCompetitionView:false})
    this.setState({competitionView:!this.state.competitionView})
  }
  handleDeleteCompetition(id){
    this.setState({selected_competition_id:id,deleteView:!this.state.deleteView})
  }
  deleteCompetition(){
        const url = `${getLocationOrigin()}/tournament/delete_tournament_competition/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.selected_competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => 
                {alert(data.message)
                this.handleDeleteCompetition();
                this.getCompetitionDetail();
              }
            )
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }

  getTournamentList() {
    console.log(this.state.id);
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_tournament/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ tournament: data.tournament}))
       .catch(error => error);
  }


  render() {
    console.log(this.state)
    var banner = this.state.tournament.banner ;
    const deleteAction = [
        <input type="button" className="button1" value="Delete" style={{backgroundColor:'red',marginRight:'10px'}} onClick={() => {this.deleteCompetition()}} />,
        <input type="button" className="button1" value="Cancel" onClick={() => {this.handleDeleteCompetition()}} />
      ];
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleCustomerSubmit}
      />,
    ];
    const okaction = 
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={() => {this.toAddCompetitionView()}}
      />;

    return(
      <div>
          <div className="breadcrumps" style={{'paddingLeft': "1%",'paddingTop':"1%"}}>
                        <a href={'/#/dashboard/ActiveCustomer'} >
                          <span>Dashboard</span>
                        </a>
                        <a href={'/#/partnerTournament'} >
                          <span>Events</span>
                        </a> 
                        <a  href={"/#/crud/viewTournament/" + this.state.tournament.id}>
                          <span>{this.state.tournament.name}</span>
                        </a>

          </div>
          <a  className="rightalign button1" target="_blank" href={"http://localhost:3000/tournament/" + this.state.tournament.id + "/"}>
            <span>Preview</span>
          </a>          
      {! this.state.competitionView &&
          <div>
        <div className="row" style={{'paddingLeft': "2%",'paddingTop':"2%"}}>

          <div style={{'display':"flex",'flexDirection':"row",'float':"left",'fontSize':"14px"}}>
              
              <Link to={`../../crud/editTournament/${this.state.id}`}>
                <input className="button1" type="button" value="Edit Event" style={styles.input_button}/>
              </Link>
              

              {/*
              <Link to={`../../crud/tournamentPricing/${this.state.id}`}>
                <input className="button" type="button" value="Edit Pricing" style={styles.input_button}/>
              </Link>
              
              <Link to={`../../crud/addTournamentTasks/${this.state.id}`}>
                    <input className="button" type="button" value="Task" style={styles.input_button}/>
              </Link>*/}

              
          </div>
          
        </div>
        
      
        
            <div className="col-md-12" style={{fontSize:'16px',padding:'1%'}}>
                <div className="col-md-12 heading2 left" style={styles.main_header}>
                    {this.state.tournament.name}
                </div>
            </div>
            <div className="col-md-12" style={{'display':"flex",'flexDirection':"row" }}>
                <div className="col-md-4">
                  <div className="col-md-6 heading2" style={styles.heading_div}>
                    Contact No. : 
                  </div>
                  <div className="col-md-6">
                  {this.state.tournament.registration_contact_number}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="col-md-6 heading2" >
                    Partners : 
                  </div>
                  <div className="col-md-6">
                  {this.state.tournament.partners && this.state.tournament.partners}
                  </div>
                </div>
                <div className="col-md-4">
                  <div style={{'display':"flexDirection",'flexDirection':"row"}}>
                    <div className="col-md-6 heading2" style={styles.heading_div}>
                      Organiser: 
                    </div>
                    <div className="col-md-6">
                          {this.state.tournament.organizers && this.state.tournament.organizers.length > 0 &&  this.state.tournament.organizers.map((organizer,index) =>
                            
                            <div>{organizer.name}</div>
                           
                          )
                          }
                    </div>
                  </div>
                </div>
            </div>
            <div className="col-md-12" >
                <div className="col-md-12" >
                  <div className="col-md-2 heading2" style={styles.heading_div}>
                    Desciption  : 
                  </div>
                  <div className="col-md-10">
                  {this.state.tournament.description }
                  </div>
                </div>
            </div>
            {/*
            <div className="col-md-12" style={{textAlign:'center'}}>
                <img id="banner" src={this.state.tournament.banner} alt="banner" />
            </div>
          */}
         <div className="col-md-12" style={{fontSize:'14px',padding:'1%'}}>
              <Link to={`../../crud/addCompetition/${this.state.id}/${this.state.tournament.name}`}>
                <input className="button1" type="button" value="Add Competition" style={styles.input_button}/>
              </Link>
        </div>
        <div style={{'padding':"1%"}}>
        
            
              <div className="col-md-12 heading2 left" style={styles.main_header}>List of Competitions </div>
            
        
        
        <div className="col-md-12   " style={styles.table} >

            
      
                    <table className="table_plain " >
                      
                      {this.state.prev_competition_details.length > 0 &&
                        <tr>
                              <th>Start Date </th>
                              <th>End Date </th>
                              <th>Competition </th>
                              <th>Category </th>
                              <th>Age group </th>
                              <th>Coordinator </th>
                              <th>Venues </th>
                              <th>Registrations </th>
                              <th>Status </th>
                              <th>Action </th>
                        </tr>
                    }
                    
                    {this.state.prev_competition_details.length > 0 && this.state.prev_competition_details.map((competition,index) =>
                    <tr key={index} >
                      <td> {competition.start_date[0]} </td>
                      <td>{competition.end_date[0]}</td>
                      <td>{competition.game[1]+ " " +competition.gender[1]} </td>
                      <td>{competition.category[1]} </td>
                      <td>{competition.age_groups[1]} </td>
                      <td>{competition.coordinator && competition.coordinator.map((buddy,index)=><div>{buddy[1]}</div>)} </td>
                      <td> {competition.venue && competition.venue.map((venue,index)=><div>{venue[1]}</div>)}</td>
                      <td> <span className="button1"> {competition.registration_count} </span></td>
                      <td> Open </td>
                      <td>
                        <Link to={"/crud/viewCompetition/" + competition.id +"/basicInfo"}>
                              <input className="button1" type="button" value="View"/>
                        </Link>
                        <i className="far fa fa-trash" style={{fontSize:'30px',paddingLeft:'10%'}} onClick={() => this.handleDeleteCompetition(competition.id)}/>
                      </td>
                    </tr>
                    )}
                    </table>
                    {this.state.deleteView && 
                                    <Dialog
                                                actions={deleteAction}
                                                modal={false}
                                                open={true}
                                                autoDetectWindowHeight={true}
                                                autoScrollBodyContent={true}
                                                scroll={scroll}
                                                dividers={scroll === 'paper'}
                                              >
                                              <h3> Do You Want To delete this Competition </h3>
                                    </Dialog>
                                }
          </div>
          </div>
        </div>
      }
      

       {this.state.competitionView &&
        <div>
            <div className="col-md-12" style={{paddingLeft:'18px',paddingTop:'18px'}}>
                <input className="button" type="button" value="Back" onClick={() => {this.onComptitionView()}} style={styles.input_button}/>
            </div>
            <CompetitionView id={this.state.competitions_id} tournament_id={this.state.id} />
        </div>

      }

        {/*
        <div className="row" style={{padding:'1%'}}>

          <div className="col-md-4" style={{padding:'1%'}}>
            <Card style={{backgroundColor:'rgb(171, 71, 188)'}}>
              <CardHeader
                title="STANDINGS"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <Table>
                  <TableHeader displaySelectAll={false}>
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Points</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {this.state.tournament.standing?this.state.tournament.standing.map((x,index) => (
                      <TableRow key={x.P+x.team}>
                        <TableRowColumn>{x.team}</TableRowColumn>
                        <TableRowColumn>{x.P}</TableRowColumn>
                      </TableRow>
                    )):''}
                  </TableBody>
                </Table>
              </CardText>
            </Card>
          </div>

          <div className="col-md-4" style={{padding:'1%'}}>
            <Card style={{backgroundColor:'rgb(171, 71, 188)'}}>
              <CardHeader
                title="TOP SCORERS"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <Table>
                  <TableHeader displaySelectAll={false}>
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Team</TableHeaderColumn>
                      <TableHeaderColumn>Goals</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {this.state.tournament.top_scorers?this.state.tournament.top_scorers.slice(0,9).map((x,index) => (
                      <TableRow key={x.customer_id}>
                        <TableRowColumn>{x.Name}</TableRowColumn>
                        <TableRowColumn>{x.Team}</TableRowColumn>
                        <TableRowColumn>{x.Goals}</TableRowColumn>
                      </TableRow>
                    )):''}
                  </TableBody>
                </Table>
              </CardText>
            </Card>
          </div>

          <div className="col-md-4" style={{padding:'1%'}}>
            <Card style={{backgroundColor:'rgb(171, 71, 188)'}}>
              <CardHeader
                title="TOP ASSISTS"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <Table>
                  <TableHeader displaySelectAll={false}>
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Team</TableHeaderColumn>
                      <TableHeaderColumn>Assists</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {this.state.tournament.top_assists?this.state.tournament.top_assists.slice(0,9).map((x,index) => (
                      <TableRow key={`a${x.customer_id}`}>
                        <TableRowColumn>{x.Name}</TableRowColumn>
                        <TableRowColumn>{x.Team}</TableRowColumn>
                        <TableRowColumn>{x.Assists}</TableRowColumn>
                      </TableRow>
                    )):''}
                  </TableBody>
                </Table>
              </CardText>
            </Card>
          </div>
        </div>

        <div className="row">
          {this.state.tournament.tournament_teams?
            this.state.tournament.tournament_teams.map((x, index) => (
            <div className="col-md-12" style={{paddingBottom: '1%'}}>
              <Card key={x.id}>
                <CardHeader
                  title={x.name}
                  actAsExpander={true}
                  showExpandableButton={true}
                  avatar={`https://api.sporthood.in/${x.logo}`}
                />
                <div style={{display:'flex', justifyContent: 'space-between'}}>
                  <div style={{display:'flex'}}>
                    <CardText>Total Collection: Rs {x.amount_paid.amount__sum}</CardText>
                    <CardText>Members: {x.count}</CardText>
                  </div>
                  <div style={{flexDirection: 'row', justifyContent: 'space-between', padding: '1px'}}>
                  <Link to={`../../crud/deleteTeam/${this.state.id}/${x.id}/`}>
                      <FlatButton
                        backgroundColor="#ec407f"
                        label="Delete Team"
                        style={{float:'right', marginLeft: '5px'}}
                      />
                    </Link>
                    <Link to={`../../crud/addTournamentTeamMember/${this.state.id}/${x.id}/${x.name}`}>
                      <FlatButton
                        backgroundColor="#c6ff00"
                        label="Add Players"
                        style={{float:'right'}}
                      />
                    </Link>
                  </div>
                </div>
                <CardText expandable={true}>
                  <GridList cols={3} padding={8}>
                    {x.tournament_members?x.tournament_members.map((y, index) => (
                        <Card style={{backgroundColor:'#BDBDBD'}} key={y.photo+y.name}>
                          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '9px 8px'}}>
                            <CardHeader
                              title={y.name + '-' + y.mobile_no}
                              avatar={y.photo=='http://www.sporthood.in/assets/img/avatar.png'?y.photo:
                              `https://api.sporthood.in/${y.photo}`}
                              style={{padding: '0px !important'}}
                            />
                            <IconButton href={`../../#/crud/editTournamentSubscription/${y.subscription.id}/${y.subscription.amount}`}>
                              <EditIcon style={{float: 'right'}}/>
                            </IconButton>
                            <IconButton href={`../../#/crud/deleteTeammember/${y.id}`}>
                              <DeleteIcon style={{float: 'right'}}/>
                            </IconButton>
                          </div>
                          <CardText>Amount Paid: {y.subscription.amount}</CardText>
                          <CardText>Package: {y.subscription.package}</CardText>
                        </Card>
                    )):''}
                  </GridList>
                </CardText>
              </Card>
            </div>
          ))
          :''}
        </div>

        <div className="row" style={{paddingTop:'3%'}}>
          {this.state.tournament.matches?
            <GridList cols={3} padding={10} cellHeight={'auto'}>
              {this.state.tournament.matches.map((x, index) => (
                <Card style={{backgroundColor:'#FFEB3B'}} key={index}>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '8px 4px'}}>
                    <CardHeader
                      title={new Date(x.session_start).toLocaleDateString()}
                      titleStyle={{fontSize: 20}}
                      style={{padding: '0px !important', marginTop: '8px'}}
                    />
                    <IconButton href={`../../#/crud/editMatch/${x.fixture_id}`}>
                      <EditIcon/>
                    </IconButton>
                    <IconButton href={`../../#/crud/deleteMatch/${x.id}`}>
                      <DeleteIcon style={{float: 'right'}}/>
                    </IconButton>
                  </div>
                  <Card key={x.fixture_session+x.team_one.name}>
                    <CardHeader
                      title={x.team_one.name + ' : ' + x.team_one.score}
                      avatar={`https://api.sporthood.in/${x.team_one.logo}`}
                    />
                  </Card>
                  <Card key={x.fixture_session+x.team_two.name}>
                    <CardHeader
                      title={x.team_two.name + ' : ' + x.team_two.score}
                      avatar={`https://api.sporthood.in/${x.team_two.logo}`}
                    />
                  </Card>
              </Card>
          ))}
          </GridList>
          :''}
        </div>
      */}
      </div>
    );
  }
}

export default ViewTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewTournament/index.js